<template>
    <div>
        <Toolbar
          :handle-delete="del"
          :handle-reset="resetForm"
          :handle-submit="onSendForm"
        />
        <TenantForm
          :errors="violations"
          :values="item"
          ref="updateForm"
          v-if="item"
        />
        <Loading :visible="isLoading || deleteLoading"/>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import TenantForm from '../../components/tenant/Form.vue';
  import Loading from '@/components/Loading';
  import Toolbar from '@/components/Toolbar';
  import UpdateMixin from '../../mixins/UpdateMixin';

  const servicePrefix = 'Tenant';

  export default {
    name: 'TenantUpdate',
    servicePrefix,
    mixins: [UpdateMixin],
    components: {
      Loading,
      Toolbar,
      TenantForm,
    },
    computed: {
      ...mapFields('tenant', {
        deleteLoading: 'isLoading',
        isLoading: 'isLoading',
        error: 'error',
        updated: 'updated',
        violations: 'violations'
      }),
      ...mapGetters('tenant', ['find'])
    },
    methods: {
      ...mapActions('tenant', {
        deleteItem: 'del',
        retrieve: 'load',
        update: 'update',
      })
    }
  };
</script>
